exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---HPz4V {\n  display: block;\n  margin: 10px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---HPz4V"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/checkbox/index.scss
// module id = 1138
// module chunks = 3